import { Component, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { sortState } from '../../../shared/utility/config';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { EmitterService } from '../../../services/emitter.service';
import { GamingUtility } from '../../../gaming/gaming.utility';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-lobby-sorting',
  templateUrl: './lobby-sorting.component.html',
  styleUrls: ['./lobby-sorting.component.scss']
})
export class LobbySortingComponent implements OnInit, OnDestroy {
  @Input() isMobileFilter: boolean = false;
  @Output() hideFilterDropDown: EventEmitter<any> = new EventEmitter<any>();
  sortOrderState = sortState.none;
  langCode;
  destroy$: Subject<boolean> = new Subject();

  constructor(
    private router: Router,
    private emitterService: EmitterService,
    private gamingUtils: GamingUtility,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
    
    this.activatedRoute.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe(queryParams => {
      if(!queryParams.get("sort")) {
        this.sortOrderState = sortState.none;
      } else {
        this.sortOrderState = sortState[queryParams.get("sort")];
      }
    })
  }

  isActiveState(state){
    if(state && state.trim() != 'none'){
      return true;
    }else {
      return false;
    }
  }
  clickSorting() {
    // this.hideFilterDropDown.emit(true);
    // this.sortOrderState = this.gamingUtils.changeState(this.sortOrderState);
    // this.router.navigate([this.langCode + '/casino/allgames'], { queryParams: { sort: this.sortOrderState }});
    this.hideFilterDropDown.emit(true);

    this.sortOrderState = this.gamingUtils.changeState(this.sortOrderState);
    this.emitterService.broadCastSortUpdate(this.sortOrderState)
    this.router.navigate([window.location.pathname], { queryParams: { sort: this.sortOrderState },queryParamsHandling: 'merge'});
  }
  
  ngOnDestroy(){
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
